module.exports = "<div class=\"app\"\n\t:style=\"{'min-height': '100vh'}\">\n\t<router-view\n\t\t:app-loaded=\"appLoaded\"/>\n\t<qd-cookie-popup></qd-cookie-popup>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/app.vhtml
// module id = 251
// module chunks = 0